import { EProfessionalRejectionStep } from "@/domain/enums/EProfessionalRejectionStep";

// A API só retorna a chave do enum — o texto em português exibido pro
// admin é definido aqui no front (mesmo padrão usado no app do profissional).
export const PROFESSIONAL_REJECTION_STEP_LABELS: Record<EProfessionalRejectionStep, string> = {
    [EProfessionalRejectionStep.PROFESSIONAL_DATA]: "Dados profissionais",
    [EProfessionalRejectionStep.PROFILE]: "Perfil",
    [EProfessionalRejectionStep.DOCUMENTS]: "Imagem dos documentos",
    [EProfessionalRejectionStep.SELFIE]: "Selfie",
    [EProfessionalRejectionStep.SPECIALTY]: "Especialidade",
    [EProfessionalRejectionStep.PRICE]: "Valor da consulta",
    [EProfessionalRejectionStep.WORKING_HOURS]: "Horários de atendimento",
    [EProfessionalRejectionStep.PAYOUT_INFO]: "Dados bancários",
};

// Formato pronto pra alimentar o SelectInput (propertyForValue="id" / propertyForText="title", padrão default do componente)
export const PROFESSIONAL_REJECTION_STEP_OPTIONS = Object.entries(
    PROFESSIONAL_REJECTION_STEP_LABELS,
).map(([id, title]) => ({ id, title }));
